export default "__VITE_ASSET__06jv3PfA__"